const LOOM = 'LOOM';
const CUSTOM = 'CUSTOM';
const YOUTUBE = 'YOUTUBE';

export const STREAMING_SERVICES_TYPES = {
	LOOM,
	CUSTOM,
	YOUTUBE,
};

export const STREAMING_SERVICES = [
	{ value: LOOM, text: 'Loom' },
	{ value: CUSTOM, text: 'Custom' },
	{ value: YOUTUBE, text: 'Youtube' },
];
